// extracted by mini-css-extract-plugin
export default {"imgWrapper":"BoxLogo_imgWrapper__7EhhG","logo":"BoxLogo_logo__ZZrdv"};